import React from 'react';
import styled from 'styled-components';
import { colors, fonts } from '../styles/globals';

const ForWhoContainer = styled.section`
  background-color: ${colors.white};
  padding: 80px 20px;
  text-align: center;

  @media (max-width: 768px) {
    padding: 60px 20px;
  }
`;

const ForWhoContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const ForWhoTitle = styled.h2`
  font-family: ${fonts.playfair};
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  color: ${colors.primary};
  margin-bottom: 16px;
  line-height: 1.2;
`;

const ForWhoSubtitle = styled.p`
  font-family: ${fonts.inter};
  font-size: 1.2rem;
  font-weight: 500;
  color: ${colors.text};
  margin-bottom: 50px;
  line-height: 1.5;
`;

const ForWhoList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 40px;
`;

const ForWhoItem = styled.div`
  background: linear-gradient(135deg, ${colors.background} 0%, #F8FBFF 100%);
  border-radius: 16px;
  padding: 25px;
  text-align: left;
  border-left: 4px solid ${colors.accent};
  transition: all 0.3s ease;

  &:hover {
    transform: translateX(5px);
    box-shadow: 0 8px 25px rgba(45, 31, 64, 0.1);
  }

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

const ForWhoText = styled.p`
  font-family: ${fonts.inter};
  font-size: 1.1rem;
  font-weight: 500;
  color: ${colors.text};
  line-height: 1.6;
  margin: 0;
`;

const ForWhoHighlight = styled.span`
  color: ${colors.primary};
  font-weight: 600;
`;

function ForWhoSection() {
  const forWhoItems = [
    'Sientes que tienes algo importante que decir pero no sabes cómo',
    'El miedo, la vergüenza o el juicio te bloquean',
    'Ya lo has intentado todo y sigues sin sentirte libre al hablar',
    'Quieres usar tu historia como motor de impacto',
    'Eres coach, terapeuta, líder o simplemente humano'
  ];

  return (
    <ForWhoContainer>
      <ForWhoContent>
        <ForWhoTitle>¿Para quién es esto?</ForWhoTitle>
        <ForWhoSubtitle>
          Este proceso es para ti si:
        </ForWhoSubtitle>

        <ForWhoList>
          {forWhoItems.map((item, index) => (
            <ForWhoItem key={index}>
              <ForWhoText>
                <ForWhoHighlight>✓</ForWhoHighlight> {item}
              </ForWhoText>
            </ForWhoItem>
          ))}
        </ForWhoList>
      </ForWhoContent>
    </ForWhoContainer>
  );
}

export default ForWhoSection; 